// Excel експортът на „Променени цени".
//
// Редовете идват ФИЛТРИРАНИ и ПОДРЕДЕНИ от таблицата (`onFilteredRowsChange`),
// не суровият отговор: файлът повтаря екрана, включително филтрите в колоните.
// БЕЗ собствен времеви печат — `exportToExcel` вече лепи `_${stamp}`.
//
// Колоните са същите като преди миграцията, включително „Вид" и „Статус",
// които на екрана са изгасени по подразбиране: в Excel мястото не се бори и
// точно там се прави разрезът по добавки и по върнати промени.
//
// Датата се форматира РЪЧНО: `toLocaleDateString("bg-BG")` добавя „ г." и
// клетката се разчита по-трудно.

import dayjs from "dayjs";

import { exportToExcel } from "../../../../utils/excelExport";
import type { PriceChangeRow } from "./priceChangesMath";

type Context = {
  t: (key: string) => string;
};

/** Числата излизат като ЧИСЛА, не форматирани низове. */
const round2 = (value: number) => Number(value.toFixed(2));

export const exportPriceChanges = (
  rows: readonly PriceChangeRow[],
  { t }: Context,
) => {
  exportToExcel<PriceChangeRow>({
    filename: t("reportsPage.priceChangesTitle"),
    sheetName: t("reportsPage.priceChanges"),
    columns: [
      {
        header: t("reportsPage.date"),
        value: (row) =>
          row.changedAt ? dayjs(row.changedAt).format("DD.MM.YYYY HH:mm") : "",
        width: 18,
      },
      {
        header: t("reportsPage.user"),
        value: (row) => row.userLabel,
        width: 22,
      },
      {
        header: t("reportsPage.table"),
        value: (row) => row.billLabel,
        width: 12,
      },
      {
        header: t("reportsPage.discountsBillId"),
        value: (row) => row.billId,
        width: 10,
      },
      {
        header: t("reportsPage.product"),
        value: (row) => row.itemLabel,
        width: 30,
      },
      {
        header: t("reportsPage.priceChangesColKind"),
        value: (row) => row.kindLabel,
        width: 14,
      },
      {
        header: t("reportsPage.qty"),
        value: (row) => row.quantity,
        width: 10,
      },
      {
        header: t("reportsPage.priceChangesOldPrice"),
        value: (row) => round2(row.oldPrice),
        width: 14,
      },
      {
        header: t("reportsPage.priceChangesNewPrice"),
        value: (row) => round2(row.newPrice),
        width: 14,
      },
      // Знаково: отрицателно = поевтиняване, положително = поскъпване. Така
      // колоната се сумира в Excel без ръчно разделяне на двете посоки.
      {
        header: t("reportsPage.priceChangesDelta"),
        value: (row) => round2(row.difference),
        width: 14,
      },
      {
        header: t("reportsPage.priceChangesLineEffect"),
        value: (row) => round2(row.lineDifference),
        width: 16,
      },
      {
        header: t("reportsPage.status"),
        value: (row) => row.statusLabel,
        width: 14,
      },
    ],
    rows: [...rows],
  });
};
